import {lazy} from 'react';

export const AnimatedKeyNumbersLazy = lazy(() => import(/* webpackChunkName: "animatedKeyNumbers" */ '.'));
